import React, { useCallback } from 'react';
import { ServicesContext } from '~/services';
import { convertPagination, defaultApiResponseHandler } from '~/util';

export interface GetUsersParamsType {
    [key: string]: string | number | null;
}
export const useGetUsers = () => {
    const services = React.useContext(ServicesContext);

    const getUsers = useCallback(
        async (params: GetUsersParamsType, options?: ApiRequestOptionsType) => {
            try {
                const result = await services.api.call(
                    {
                        method: 'get',
                        url: '/api/users',
                        params,
                        data: {},
                        headers: {
                            'Content-Type': 'application/ld+json',
                        },
                    },
                    options
                );

                return {
                    results: result.data['hydra:member'],
                    pagination: convertPagination(result.data),
                };
            } catch (error) {
                throw defaultApiResponseHandler(error);
            }
        },
        [services.api]
    );

    return getUsers;
};
